import { FC, useEffect, useState } from 'react';
import SelectRuleGroupModalChildren from './ModalChildren';
import { getEdgeDeviceInfoSimple, EdgeDeviceDetailSimple } from '../../../../api/edgeDevice';
import { Device } from '../../../../api/device';
import styles from './index.module.scss';
import { IotProtocolType } from '@/shared/types';
import { Modal } from '@maxtropy/components';
import { isNil } from 'lodash-es';
import {
  apiV2RuleDeviceBindPost,
  apiV2RuleDeviceGetBindRuleListPost,
  apiV2RuleDeviceUnbindAllRuleByDeviceIdPost,
} from '@maxtropy/device-customer-apis-v2';
interface SelectRuleGroupModalProps {
  device?: Device;
  disabledRule: boolean;
  onClose: () => void;
  updateFn?: () => void;
  visible?: boolean;
  isThirdRuleGroup?: boolean;
  thirdRuleTypeId?: number;
  physicalModelId?: number;
}

const SelectRuleGroupModal: FC<SelectRuleGroupModalProps> = ({
  device,
  disabledRule,
  onClose,
  updateFn,
  visible = false,
  isThirdRuleGroup,
  thirdRuleTypeId,
  physicalModelId,
}) => {
  const [ruleGroupId, setRuleGroupId] = useState<number[]>();
  const [info, setInfo] = useState<EdgeDeviceDetailSimple>();

  useEffect(() => {
    if (device) {
      apiV2RuleDeviceGetBindRuleListPost({ deviceId: device.id }).then(res => {
        if (res) {
          const ids = (res.list ?? []).map(i => i.id).filter((id): id is number => id !== undefined);
          setRuleGroupId(ids);
        }
      });
    }
  }, [device]);

  useEffect(() => {
    if (!isThirdRuleGroup) {
      if (device) {
        getEdgeDeviceInfoSimple(device.id.toString()).then(res => {
          if (res) {
            setInfo(res);
          }
        });
      } else {
        setInfo(undefined);
      }
    }
  }, [device, isThirdRuleGroup]);

  const onOk = () => {
    if (device) {
      apiV2RuleDeviceBindPost({
        deviceId: [device.id],
        ruleId: ruleGroupId,
      }).then(res => {
        onClose();
        updateFn?.();
      });
    }
  };

  const unBind = () => {
    // ruleGroupId &&
    if (device) {
      Modal.confirm({
        title: '确定解绑？',
        okText: '继续',
        onOk: () => {
          if (isNil(device.id)) return;
          apiV2RuleDeviceUnbindAllRuleByDeviceIdPost({ deviceId: device.id, ruleIdList: [] }).then(res => {
            if (res.flag) {
              onClose();
              updateFn?.();
            }
          });
        },
      });
    }
  };

  return (
    <Modal
      className={styles.modal}
      title="规则选择"
      open={visible}
      destroyOnClose
      onOk={onOk}
      onCancel={onClose}
      size="large"
    >
      {device && info && (
        <SelectRuleGroupModalChildren
          disabled={disabledRule}
          value={ruleGroupId}
          onChange={setRuleGroupId}
          unBind={unBind}
          deviceId={device.id}
          iotProtocol={info.iotProtocol}
          deviceTypeId={info.deviceTypeId}
          physicalModelId={physicalModelId}
        />
      )}
      {device && isThirdRuleGroup && (
        <SelectRuleGroupModalChildren
          value={ruleGroupId}
          disabled={disabledRule}
          onChange={setRuleGroupId}
          unBind={unBind}
          deviceId={device.id}
          iotProtocol={IotProtocolType.LONGSHINE}
          deviceTypeId={thirdRuleTypeId}
          physicalModelId={physicalModelId}
        />
      )}
    </Modal>
  );
};

export default SelectRuleGroupModal;
